import Confetti from "../components/confetti";

$(document).ready(function () {
    let progress = $('.client-profile-card-container').find('.progress');
    let primary = progress.data('primary-color');
    let secondary = progress.data('secondary-color');
    let time = progress.data('duration') || 5;

    let colors = [primary, secondary];
    if (progress.data('goal-reached') === true) {
        new Confetti(colors, time);
    }
});
